/**
 * Obtiene el breakpoint activo según el ancho del contenedor.
 * Orden: lg -> md -> sm -> xs -> xxs (de mayor a menor min-width).
 * @param {number} width - Ancho en px
 * @param {Object} breakpoints - { lg: 1200, md: 996, ... }
 * @returns {string} Breakpoint activo
 */
export const getBreakpointFromWidth = (width, breakpoints) => {
  const order = ['lg', 'md', 'sm', 'xs', 'xxs'];
  for (const bp of order) {
    if (width >= (breakpoints[bp] ?? 0)) return bp;
  }
  return 'xxs';
};
